import React from 'react'

import { Box, Typography } from '@mui/material'
import { DatePickerProps } from '@mui/x-date-pickers'

import * as S from './DatePicker.styles'

export interface DatePickerComponent<T, U> extends DatePickerProps<T, U> {
  label?: string
  helperText?: string
  error?: boolean
}

export const DatePicker: React.FC<DatePickerComponent<any, any>> = ({
  label,
  helperText,
  error,
  ...rest
}) => {
  return (
    <Box width="100%">
      <Typography
        mb="4px"
        variant="smLight"
        sx={(theme) => ({
          // neutral[200] é a cor de label de campo do sistema (mesma do
          // Textfield e do Select da library). Preto puro deixava o label do
          // DatePicker mais escuro que o do campo vizinho.
          color: error ? theme.palette.error[300] : theme.palette.neutral[200]
        })}
      >
        {label}
      </Typography>
      <S.DatePicker
        {...rest}
        error={error}
        PopperProps={{
          placement: 'bottom-start'
        }}
        maxDate={
          !rest.maxDate
            ? new Date(new Date().setFullYear(new Date().getFullYear() + 2))
            : rest.maxDate
        }
        InputProps={{
          sx: {
            fontSize: '14px'
          }
        }}
      />
      {helperText && (
        <Typography color="#CC2942" mt="4px" variant="xsBold">
          {helperText}
        </Typography>
      )}
    </Box>
  )
}
